export default (type) => {
  return type === 'main' || type === 'other' || type === undefined || type === null || type===''
}
